export const getUserById = <T extends NamedUser>(users: T[], id: number | string) =>
  users.find(patient => patient.id === (typeof id === 'number' ? id : parseInt(id)))

// Accepts either a snake_case API user (patient or provider) or a camelCase
// shape from non-API callers; the `??` fallbacks below serve both.
export type NamedUser = {
  id: number
  first_name?: string | null
  last_name?: string | null
  firstName?: string
  lastName?: string
}
export const getUserName = (user?: NamedUser) => {
  if (!user) {
    return 'Unknown User'
  }

  const first_name = user.first_name ?? user.firstName
  const last_name = user.last_name ?? user.lastName
  if (first_name && last_name) {
    return `${first_name} ${last_name}`
  }
  if (!first_name && !last_name) {
    return ''
  }
  return first_name || last_name
}

export const getUserInitials = (user: NamedUser) => {
  const first_name = user.first_name ?? user.firstName
  const last_name = user.last_name ?? user.lastName
  return (first_name ?? '').slice(0, 1) + (last_name ?? '').slice(0, 1)
}
